import React, { useEffect, useState } from 'react';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { IAction } from '../../../../types/Action/IAction';

interface StopwatchImageProps extends ITicketProps {
    actionId: number;
}

const StopwatchImage: React.FC<IAction> = ({ ID, Call_Id }) => {
    const { data: watches } = TicketApi.useGetStopwatchesQuery(Call_Id);
    const [imageSrc, setImageSrc] = useState<string>('');
    const actionWatches = watches?.find(watch => watch.Call_Action_Id === ID && watch.IsTicking === true);

    if (!actionWatches) return null;

    return (
        <>
            <img style={{ marginTop: '6px' }} width={20} height={20} src={'./images/stopwatch_on.gif'} alt={'Stopwatch Ticking'} />
        </>
    );
};

export default StopwatchImage;